(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lalesia-home"] && !Shopify.designMode) return;
  try {
    
class LalesiaFilm extends HTMLElement {
  connectedCallback(){
    this.video=this.querySelector('video');this.button=this.querySelector('button');if(!this.video||!this.button)return;
    this.controller=new AbortController();const options={signal:this.controller.signal};
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.video.muted=true;this.video.controls=false;this.button.hidden=false;
    const update=()=>{this.button.querySelector('[data-pause]').hidden=this.video.paused;this.button.querySelector('[data-play]').hidden=!this.video.paused;};
    this.button.addEventListener('click',()=>{if(this.video.paused)this.video.play().catch(update);else this.video.pause();},options);
    this.video.addEventListener('play',update,options);this.video.addEventListener('pause',update,options);
    this.motion.addEventListener('change',()=>{if(this.motion.matches)this.video.pause();},options);
    update();if(!this.motion.matches)this.video.play().catch(update);
  }
  disconnectedCallback(){this.controller?.abort();this.video?.pause();}
}
if(!customElements.get('lalesia-film'))customElements.define('lalesia-film',LalesiaFilm);

class LalesiaStory extends HTMLElement {
 connectedCallback(){
  this.slides=[...this.querySelectorAll('[data-story-slide]')];if(!this.slides.length)return;
  this.index=0;this.controller=new AbortController();const options={signal:this.controller.signal};this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;this.visible=false;
  this.controls=this.querySelector('.ll-story-controls');this.controls.hidden=this.slides.length<2;
  this.querySelector('[data-story-prev]').addEventListener('click',()=>{this.show(this.index-1);this.restart();},options);
  this.querySelector('[data-story-next]').addEventListener('click',()=>{this.show(this.index+1);this.restart();},options);
  this.querySelector('[data-story-pause]').addEventListener('click',()=>{this.paused=!this.paused;this.sync();this.restart();},options);
  this.addEventListener('focusin',()=>this.stop(),options);this.addEventListener('focusout',()=>this.restart(),options);
  document.addEventListener('visibilitychange',()=>this.restart(),options);
  this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.sync();this.restart();},options);
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.restart();},{threshold:.15});this.observer.observe(this);
  this.addEventListener('shopify:block:select',e=>{const target=e.target.closest('[data-story-slide]');const i=this.slides.indexOf(target);if(i>=0){this.paused=true;this.show(i);this.sync();this.stop();}},options);
  this.show(0);this.sync();
 }
 show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>{const active=n===this.index;s.classList.toggle('is-active',active);s.setAttribute('aria-hidden',String(!active));s.inert=!active;});this.querySelector('[data-story-count]').textContent=(this.index+1)+' / '+this.slides.length;}
 sync(){this.querySelector('[data-story-pause-label]').hidden=this.paused;this.querySelector('[data-story-play-label]').hidden=!this.paused;}
 stop(){clearInterval(this.timer);}
 restart(){this.stop();if(!this.paused&&this.visible&&!document.hidden&&!this.contains(document.activeElement)&&this.slides.length>1)this.timer=setInterval(()=>this.show(this.index+1),5000);}
 disconnectedCallback(){this.stop();this.observer?.disconnect();this.controller?.abort();}
}
if(!customElements.get('lalesia-story'))customElements.define('lalesia-story',LalesiaStory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lalesia-product-autoplay')) {
    customElements.define('lalesia-product-autoplay', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('[data-testid="product-list"]');
        this.button = this.querySelector('button');
        this.paused = false;
        this.hovered = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reducedMotion.matches;
        this.updateButton = () => {
          this.button.textContent = this.paused ? 'Automatischen Wechsel starten' : 'Automatischen Wechsel pausieren';
          this.button.setAttribute('aria-pressed', String(this.paused));
        };
        this.button.addEventListener('click', () => { this.paused = !this.paused; this.updateButton(); });
        this.onEnter = () => { this.hovered = true; };
        this.onLeave = () => { this.hovered = false; };
        this.section.addEventListener('pointerenter', this.onEnter);
        this.section.addEventListener('pointerleave', this.onLeave);
        this.updateButton();
        this.timer = window.setInterval(() => {
          if (this.paused || document.hidden || this.section.contains(document.activeElement)) return;
          const carousel = this.section.querySelector('slideshow-component[ref="resourceListCarousel"]');
          const scroller = carousel?.querySelector('slideshow-slides');
          if (!scroller || carousel.getAttribute('disabled') === 'true') return;
          const bounds = carousel.getBoundingClientRect();
          if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
          const originals = Array.from(scroller.children).filter(slide => slide.tagName === 'SLIDESHOW-SLIDE' && !slide.hasAttribute('data-loop-copy'));
          if (originals.length < 2) return;
          const step = originals[1].offsetLeft - originals[0].offsetLeft;
          if (!scroller.querySelector('[data-loop-copy]')) {
            originals.forEach((slide) => {
              const copy = slide.cloneNode(true);
              copy.setAttribute('data-loop-copy', '');
              copy.removeAttribute('ref');
              copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
              copy.querySelectorAll('a, button, input').forEach(element => element.setAttribute('tabindex', '-1'));
              scroller.appendChild(copy);
            });
          }
          const firstCopy = scroller.querySelector('[data-loop-copy]');
          const loopDistance = firstCopy.offsetLeft - originals[0].offsetLeft;
          this.animateScroll(scroller, Math.min(scroller.scrollLeft + step, loopDistance), loopDistance);
        }, 3000);
      }

      animateScroll(scroller, target, loopDistance) {
        const start = scroller.scrollLeft;
        const end = Math.max(0, Math.min(target, scroller.scrollWidth - scroller.clientWidth));
        const snap = scroller.style.scrollSnapType;
        const behavior = scroller.style.scrollBehavior;
        scroller.style.scrollSnapType = 'none';
        scroller.style.scrollBehavior = 'auto';
        const started = performance.now();
        const frame = (now) => {
          const progress = Math.min(1, (now - started) / 1200);
          const eased = progress * progress * (3 - 2 * progress);
          scroller.scrollTo({ left: start + (end - start) * eased, behavior: 'instant' });
          if (progress < 1 && this.isConnected) this.animation = requestAnimationFrame(frame);
          else {
            if (loopDistance && end >= loopDistance - 2) scroller.scrollTo({ left: end - loopDistance, behavior: 'instant' });
            scroller.style.scrollSnapType = snap; scroller.style.scrollBehavior = behavior;
          }
        };
        this.animation = requestAnimationFrame(frame);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.animation);
        window.clearInterval(this.timer);
        this.section?.removeEventListener('pointerenter', this.onEnter);
        this.section?.removeEventListener('pointerleave', this.onLeave);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
